<template>
  <section>
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: "BusinessesView"
}
</script>

<style scoped lang="stylus">
</style>
